import * as React from 'react';
import { loadingScheduler } from '../../../services/loading-scheduler';

export class LazyChatRoomScreen extends React.Component<{ banner: boolean }> {
  ChatRoomScreen;
  Branding;

  componentDidMount() {
    void loadingScheduler.onInteractive().then(async () => {
      this.ChatRoomScreen = (await import(/* webpackChunkName: "chat-interactivity" */ '@wix/chat-web/dist/src/components/ChatRoomScreen/ChatRoomScreen')).default;
      this.Branding = (await import(/* webpackChunkName: "chat-interactivity" */ '../../Branding/Branding')).default;
      this.forceUpdate();
    });
  }

  render() {
    return this.ChatRoomScreen ? (
      <this.ChatRoomScreen
        {...this.props}
        banner={this.props.banner === true ? <this.Branding /> : undefined}
      />
    ) : (
      <div />
    );
  }
}
